import React from 'react';
import { useNavigate } from 'react-router-dom';
import { NavBar, List } from 'antd-mobile';
import { t } from '../../i18n';

const SupportToolsPage: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-white">
            <NavBar onBack={() => navigate(-1)}>
                {t('supportTools.title')}
            </NavBar>
            <List>
                <List.Item onClick={() => navigate('/support-tools/support-login')}>
                    {t('supportTools.supportLogin.title')}
                </List.Item>
            </List>
        </div>
    );
};

export default SupportToolsPage;
